
export type validationFn = (field: string, value: any) => string[] | null;
export type formValidationFn = (form: any, field: string, value: any) => string | null;

export interface FormField {
  name?: string;
  value?: any;
  validation?: validationFn;
  errors?: string[] | null;
  touched?: boolean;
  changed?: boolean;
};

export class FormGroup {
  constructor(fields: { [key: string]: FormField }, validations?: formValidationFn[]) {
    this.fields = Object.keys(fields)
      .reduce((acc, cur) => {
        if (fields[cur]) {
          return { ...acc, [cur]: { ...fields[cur], name: cur } };
        } else {
          return acc;
        }
      }, {});
    this.formValidations = validations;
    Object.values(this.fields).forEach(val => this.validField(val.name, val.value));
  }

  fields: { [key: string]: FormField };
  formValidations?: formValidationFn[]

  updateField(field, value) {
    if (this.fields[field] && this.fields[field].validation) {
      const errors = this.validField(field, value);
      if (errors && (errors.length > 0)) {
        this.fields[field].errors = errors;
      } else {
        this.fields[field].errors = null;
      }
      this.fields[field].value = value;
      this.fields[field].changed = true;
      this.runFormValidations();
      return true;
    }
    this.runFormValidations();
    return false;
  }

  runFormValidations() {
    if (this.formValidations && (this.formValidations.length > 0)) {
      const results = this.formValidations.map(validation => validation(this, '', ''));
    }
  }

  validField(field, value) {
    if (this.fields[field] && this.fields[field].validation) {
      const errors = this.fields[field].validation(field, value);
      if (errors) {
        this.fields[field].errors = errors;
        return errors;
      } else {
        this.fields[field].errors = null;
        return null;
      }
    } else {
      return null;
    }
  }

  valid() {
    return !Object.values(this.fields).some(val => (val.errors && (val.errors.length > 0)));
  }

  value() {
    return Object.values(this.fields).reduce((acc, cur) => { return { ...acc, [cur.name]: cur.value } }, {}); //Object.values(this.fields).map(field => field.value)
    //.reduce((acc, curr) => { return { ...acc, [curr.name]: curr } }, {});
  }

  validations = DefaultValidations;
};

export const DefaultValidations = {
  isRequired: (field, val, log = false) => {
    if (!val) {
      if (log) {
        console.log(`${field}.!isRequired(${val})`);
      }
      return `Campo obrigatório`;
    }
  },
  isString: (field, val, log = false) => {
    if ((!val) || (typeof val).toLowerCase() !== 'string') {
      if (log) {
        console.log(`${field}.!isString(${val})`);
      }
      return `${field}!isString(${val})`;
    }
  },
  emailRegex: /[A-Z0-9._%+-]+@[A-Z0-9.-]+[.]+[A-Z]{2,4}/igm,
  isEmail: (field, val, log = false) => {
    const reg = new RegExp(DefaultValidations.emailRegex);
    if (!reg.test((val || '').trim())) {
      if (log) {
        console.log(`${field}.!isEmail(${val})`);
      }
      return `E-mail inválido`;
    }
  },
  minWidth: (field, val, len, log = false) => {
    if ((val || '').trim().length < len) {
      if (log) {
        console.log(`${field}.!minWidth(${len}, ${val})`);
      }
      return `Mínimo de ${len} caracteres`;
    }
  },
  maxWidth: (field, val, len, log = false) => {
    if ((val || '').trim().length > len) {
      if (log) {
        console.log(`${field}.!maxWidth(${len}, ${val})`);
      }
      return `Máximo de ${len} caracteres`;
    }
  },
  confirmPass: (form, field, val, log = false): string => {
    if ((form.fields.password.value || '').trim() !== (form.fields.confPassword.value || '').trim()) {
      if (log) {
        // console.log(`${field}.!confirmPass(${pass()}, ${val})`);
      }
      form.fields.confPassword.errors = form.fields.confPassword.errors || [];
      form.fields.confPassword.errors.push(`A confirmação está diferente da senha`);
      return `A confirmação está diferente da senha`;
    }
  },
  sanitizeName: (field, val, log = false): string => {
    return (val || '').trim().replace(/[^0-9a-zA-Z_\-@.&' ]/gi, '');
  },
  sanitizeEmail: (field, val, log = false): string => {
    return (val || '').trim().replace(/[^0-9a-zA-Z_\-@.]/gi, '');
  },
  sanitizePhone: (field, val, log = false): string => {
    return (val || '').toString().trim().replace(/[^0-9()+-]/gi, '');
  },
  sanitizePass: (field, val, log = false): string => {
    return (val || '').trim().replace(/[ ]/gi, '');
  },
}
